import { createSlotRecipe } from './runtime';

const checkboxConfig = {"name":"checkbox","slots":["root","control","icon","label"],"defaultVariants":{"size":"md"},"variantMap":{"size":["sm","md","lg"]}}

export const checkbox = /* @__PURE__ */ createSlotRecipe(checkboxConfig)